import { cn } from '@/lib/utils';

export default function Chip({
  text,
  className = '',
}: {
  text: string;
  className?: string;
}) {
  if (!text) return null;

  return (
    <div
      className={cn(
        'px-8 rounded-full h-[3.875rem] flex flex-col items-center justify-center text-center w-fit bg-[var(--prose-heading-color)]',
        className
      )}
    >
      <span className="text-white uppercase text-base font-medium leading-[2.12rem] tracking-[-0.06rem]">
        {text}
      </span>
    </div>
  );
}
